import { useContext } from "react";
import profileContext from "./context";

const useProfileContext = () => useContext(profileContext)

export default useProfileContext